<template>
	<ParamWrapper v-bind="wrapperProps" @input-data-closed="onDataInputMenuClose">
		<DefaultPropertyInput v-bind="componentProps" v-on="componentListeners" />
		<template v-slot:input-data>
			<slot name="input-data">
				<JSONDataInputMenu :param="param" v-on="dataInputListeners" ref="data-input-menu" />
			</slot>
		</template>
	</ParamWrapper>
</template>

<script>
import JSONDataInputMenu from '../DataInputMenus/JSONDataInputMenu';
import ParamTypeMixin from './mixins/ParamTypeMixin';
import IsTextAreaMixin from './mixins/ParamPropertiesMixins/IsTextAreaMixin';
import ParamTypeExtenderDataInputMenuMixin from './mixins/ParamTypeExtenderDataInputMenuMixin';
import ThisFlowMixin from './mixins/ThisFlowMixin';
import DefaultPropertyInput from '../inputsComponents/DefaultPropertyInput';
import ParamTypeHelper from './param-type-helper';
export default {
	name: 'JSONParamType',
	mixins: [ParamTypeMixin, ParamTypeExtenderDataInputMenuMixin, ThisFlowMixin, IsTextAreaMixin],
	components: { JSONDataInputMenu, DefaultPropertyInput },
	methods: {},
	computed: {
		componentConfig() {
			const RICH_TEXT_BOX_PROPS = {
				...this.$attrs,
				readonly: this.readonly,
				inputFieldHint: this.param.placeholder,
				textAreaMode: this.isTextArea,
				value: this.localValue,
				ref: 'richEditor',
				isFocused: this.isFocused,
				showDataMenu: this.showDataMenu,
			};

			const RICH_TEXT_BOX_LISTENERS = {
				focus: this.onInputFocus,
				click: () => this.onInputClick(true),
				blur: this.onInputBlur,
				open: this.openDataInputMenu,
				input: (val) => (this.localValue = val),
				'content-updated': this.onContentUpdate,
			};

			const REGULAR_PROPERTY_INPUT_CONFIG = ParamTypeHelper.buildComponentConfigItem(
				DefaultPropertyInput,
				RICH_TEXT_BOX_PROPS,
				RICH_TEXT_BOX_LISTENERS
			);

			return REGULAR_PROPERTY_INPUT_CONFIG;
		},
		componentProps() {
			return this.componentConfig.props;
		},
		componentListeners() {
			return this.componentConfig.listeners;
		},
	},
	data() {
		return {};
	},
	watch: {
		componentConfig: {
			handler() {
				this.$nextTick(() => {
					this.setInputElement(this.$refs['richEditor']?.$el);
				});
			},
		},
	},
};
</script>
<style lang="scss" scoped></style>
